import { Employee } from "services";
import { useAppDispatch, useAppSelector } from "stores";

import { employeeSlice } from "./reducers";

export const useEmployeeStore = () => {
  const dispatch = useAppDispatch();
  const employees = useAppSelector((state) => state?.employee.employees);
  const employeesChecked = useAppSelector(
    (state) => state?.employee.employeesChecked
  );

  const setListEmployees = (newEmployees: Employee[]) => {
    dispatch(employeeSlice.actions.setListEmployees(newEmployees));
  };
  const setListEmployeeChecked = (ids: number[]) => {
    const listEmployee = employees.filter((item) => ids.includes(item.id));
    dispatch(
      employeeSlice.actions.setEmployeeChecked(
        listEmployee.map((item) => ({
          id: item.id,
          orgId: item.organizationId,
        }))
      )
    );
  };
  const reset = () => {
    dispatch(employeeSlice.actions.reset());
  };

  return {
    employees,
    employeesChecked,

    setListEmployees,
    setListEmployeeChecked,
    reset,
  };
};
